import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { isAuthenticated } from "@/auth";
import { LoginInstallflow } from "@/components/installFlowV2/login-install-flow";

const fallback = "/organization" as const;

export const Route = createFileRoute("/installFlow/auth-install-flow")({
  component: LoginInstallflow,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
 
});
